<template>

  <section class="send-sms-page">
    <h1>Send Arbitrary SMS</h1>
    <div class="main-container">
      <div class="form-block">
        <span class="title">Phone No.</span>
        <!--          <el-form-item prop="addr_room">-->
        <!-- <v-input v-model="phone" /> -->
        <!--          </el-form-item>-->
        <!-- <v-button
          class="button"
          type="info">Add More Recipients</v-button> -->
        <v-input-select
          v-model="phone"
          labelKey="phone"
          :valueKey="'phone'"
          :list="customerOptionsPhone"
          @input="remoteMethod"
          @changeData="changePhone">
          <template #default="scope">
            <div class="send-info">
              <div class="info">
                <span v-if="scope.item.name!=''">{{scope.item.name}} - </span>
                <span> {{ scope.item.phone }}</span>
              </div>
            </div>
          </template>
        </v-input-select>
      </div>
      <div class="form-block">
        <span class="title">Content</span>
        <!--          <el-form-item prop="content">-->
        <v-input
          v-model="content"
          type="textarea"
          :rows="6"/>
        <!--          </el-form-item>-->
        <v-button
          type="success"
          class="button"
          size="mini"
          @click="onSend"
        >Send</v-button>
      </div>
    </div>
  </section>

</template>

<script>
import {mapActions, mapState} from 'vuex'
import {sendSMS} from '@/api/ticket'

export default {
  name: 'sendArbitrarySms',
  data(){
    return{
      phone:'',
      content:'',
      customerId: '',

    }
  },
  computed: {
    ...mapState('common', ['customerOptionsPhone'])
  },
  methods: {
    ...mapActions('common', ['getCustomerOptionsPhone', 'setCustomerOptionNUll']),
    remoteMethod(query, type) {
      if (query !== '') {
        this.getCustomerOptionsPhone(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    changePhone(data) {
      this.phone = data.phone
    },
    onSend() {
      this.network().sendSMS()
    },
    network() {
      return {
        sendSMS: async () => {
          const { data } = await sendSMS({
            content: this.content,
            phone: this.phone,
            customer_id: this.customerId
          })
          this.$message({
            type: 'success',
            message: data.message_language || data.message
          })
          this.content = ''
          this.customerId = ''
          this.phone = ''
        },
      }
    }
  }
}
</script>

<style scoped lang="scss" >
  .send-sms-page{
      margin-top: 10px;
      h1{
        color: #303133;
        font-family: "Helvetica Neue";
        font-size: 34px;
        font-weight: bold;
      }
    .main-container{
      width: 432px;
      border-radius: 4px;
      background-color: #FFFFFF;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    }
    .form-block{
      padding: 15px;
      .button{
        margin-top: 15px;
      }
      .title{
        color: #616266;
        font-family: "Helvetica Neue";
        font-size: 14px;
        font-weight: bold;
        margin: 6px 0;
      }
    }
  }
</style>